import { render, staticRenderFns } from "./BoardSettingPage.vue?vue&type=template&id=0b981fd0&"
import script from "./BoardSettingPage.vue?vue&type=script&lang=js&"
export * from "./BoardSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports